/**
 * ceci le container de contenue du collapse flux des employées
 */
import React, { memo, useState } from "react";

import FilterFlow from "./filterFlow";
import TableEmployerFlow from "./tableEmployerFlow";

const EmployerFlow = ({ setSuperZIndex, toggleLoadProtocol }) => {
  const [filterValue, setFilterValue] = useState(null);

  return (
    <div className="-arh-mt-2 arh-w-full arh-bg-white arh-p-4 arh-px-9">
      <FilterFlow
        setFilterValue={setFilterValue}
        setSuperZIndex={setSuperZIndex}
      />
      <TableEmployerFlow
        filterValue={filterValue}
        toggleLoadProtocol={toggleLoadProtocol}
      />
    </div>
  );
};

export default memo(EmployerFlow);
